module.exports = __webpack_public_path__ + "static/img/317.9e55101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/317.png
// module id = FNtX
// module chunks = 0